import { Button } from "components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "components/ui/dialog";
import { CircleAlert, CircleCheckBig, TriangleAlert } from "lucide-react";

import { useTranslation } from "react-i18next";
import { StatusMsg } from "utils";
import { DialogMessageProps } from "utils/enum/dialogMessageProps";

interface DialogProps {
  setIsDialogOpen: (value: boolean) => void;
  dialogMessageProps: DialogMessageProps;
}

export function DialogShow({ setIsDialogOpen, dialogMessageProps }: DialogProps) {
  const { t } = useTranslation();
  console.log(dialogMessageProps.title, "status");

  return (
    <Dialog open={dialogMessageProps.isOpen} onOpenChange={setIsDialogOpen}>
      <DialogContent className="max-w-md text-center pt-[50px]  ">
        {dialogMessageProps.title === "info" ||
          (dialogMessageProps.title === "success" && (
            <>
              <CircleCheckBig className="mx-auto w-[100px] h-[100px] text-green-500" />
            </>
          ))}
        {dialogMessageProps.title === "warning" && (
          <>
            <CircleAlert className="text-yellow-500 mx-auto w-[100px] h-[100px]" />
          </>
        )}
        {dialogMessageProps.title === "error" && (
          <>
            <TriangleAlert className="text-red-600 mx-auto w-[100px] h-[100px]" />
          </>
        )}

        <DialogHeader className=" flex items-center justify-center">
          <DialogTitle className="text-lg font-semibold ">
            <h1
              className={`text-[30px] font-semibold   ${
                dialogMessageProps.title === "success" || dialogMessageProps.title === "info"
                  ? "text-green-500"
                  : dialogMessageProps.title === "warning"
                  ? "text-yellow-500"
                  : "text-red-500"
              }`}
            >
              {dialogMessageProps.title === "success"
                ? "success"
                : dialogMessageProps.title === "info"
                ? "Infomation"
                : dialogMessageProps.title === "warning"
                ? "warning"
                : "error"}
            </h1>
          </DialogTitle>
          <DialogDescription className=" text-muted-foreground text-md pt-3 ">{dialogMessageProps.message}</DialogDescription>
        </DialogHeader>
        <div className=" flex items-center justify-end gap-4 mt-[20px]">
          <Button
            className={`  ${dialogMessageProps.barrierDismissible ? "bg-blue-500 hover:bg-blue-500" : ""} hover:scale-110 transition-all duration-300 px`}
            variant="destructive"
            onClick={() => {
              setIsDialogOpen(false);
            }}
          >
            Ok
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

